//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data(){
        return{
            active: 'one',
        }
    },
    methods:{
        onChangetab(i){
            if(i == 1){
                this.active = 'one'
                this.$emit('changeTab',1)
            }
            if(i == 2){
                this.active = 'two'
                this.$emit('changeTab',2)
            }
            if(i == 3){
                this.active = 'three'
                this.$emit('changeTab',3)
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/home/tabbar.vue